import React from "react";
import { ButtonGroup } from "@mui/material";

import { StyledHubButton } from "./styles";

export const HubButtonGroup = ({
  buttons,
  selected,
  setSelected = () => {},
  buttonProps,
  allowNeutral = false,
  disabled,
  ...rest
}) => {
  const handleClick = (id) => setSelected(id);
  const unselected = allowNeutral
    ? { color: "neutral", className: "HubButtonGroup-button" }
    : {};

  return (
    <ButtonGroup size="small" aria-label="Small button group" {...rest}>
      {buttons?.map((button) => (
        <StyledHubButton
          icon={button?.icon}
          iconProps={{ size: "12px" }}
          label={button.label}
          onClick={() => handleClick(button.id)}
          size="xsmall"
          disabled={disabled}
          {...(selected == button.id
            ? { variant: "contained", className: "HubButtonGroup-selected" }
            : unselected)}
          {...buttonProps}
        />
      ))}
    </ButtonGroup>
  );
};

export default HubButtonGroup;
